import * as React from "react"
import {Box, Card, CardContent, Typography, Grid} from "@mui/material"
import AssignmentIcon from "@mui/icons-material/Assignment"
import PersonIcon from "@mui/icons-material/Person"
import PersonOffIcon from "@mui/icons-material/PersonOff"
import GroupIcon from "@mui/icons-material/Group"

import {batchesSummaryMetrics} from "../@signals"


function MetricCard({ title, value, subtitle, icon, color = "primary.main" }) {
    const colorBase = color.split('.')[0]
    return (
        <Card sx={{ height: '100%' }}>
            <CardContent sx={{ py: 1.5, px: 2, '&:last-child': { pb: 1.5 } }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box>
                        <Typography variant="caption" color="text.secondary" sx={{ textTransform: 'uppercase', fontWeight: 500 }}>
                            {title}
                        </Typography>
                        <Typography variant="h4" fontWeight="bold" color={color}>
                            {value}
                        </Typography>
                        {subtitle && (
                            <Typography variant="caption" color="text.secondary">
                                {subtitle}
                            </Typography>
                        )}
                    </Box>
                    <Box sx={{
                        bgcolor: `${colorBase}.lighter`,
                        borderRadius: 2,
                        p: 1,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        {React.cloneElement(icon, { sx: { fontSize: 28, color: `${colorBase}.dark` } })}
                    </Box>
                </Box>
            </CardContent>
        </Card>
    )
}


export default function BatchesSummaryCards() {
    const metrics = batchesSummaryMetrics.value

    if (metrics.totalBatches === 0) {
        return null
    }

    return (
        <Grid container spacing={2} sx={{ mb: 2 }}>
            <Grid item xs={12} sm={6} md={3}>
                <MetricCard
                    title="Pending Tasks"
                    value={metrics.totalPendingTasks.toLocaleString()}
                    subtitle={`${metrics.totalBatches} ready batch${metrics.totalBatches !== 1 ? 'es' : ''}`}
                    icon={<AssignmentIcon />}
                    color="primary.main"
                />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
                <MetricCard
                    title="Assigned"
                    value={metrics.assignedTasks.toLocaleString()}
                    subtitle={`${metrics.assignedBatches} batch${metrics.assignedBatches !== 1 ? 'es' : ''}`}
                    icon={<PersonIcon />}
                    color="success.main"
                />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
                <MetricCard
                    title="Unassigned"
                    value={metrics.unassignedTasks.toLocaleString()}
                    subtitle={`${metrics.unassignedBatches} batch${metrics.unassignedBatches !== 1 ? 'es' : ''}`}
                    icon={<PersonOffIcon />}
                    color="warning.main"
                />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
                <MetricCard
                    title="Active Users"
                    value={metrics.distinctUsersCount}
                    subtitle="working on batches"
                    icon={<GroupIcon />}
                    color="info.main"
                />
            </Grid>
        </Grid>
    )
}
